<!--  -->
<template>
  <div>
    <el-button class="addbutton" type="primary" plain @click="addConfig">添加</el-button>
    <!-- <el-dialog
      title="添加"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <Bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog> -->
    <div class="box">
      <el-table :data="FriendsList" :cell-style="{ 'text-align': 'center' }" border style="width: 100%">
        <el-table-column align="center" label="全部员工" width="230" prop="is_all">
          <template slot-scope="scope">
            {{ scope.row.is_all == '1' ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="添加人次" prop="add_num" width="180" />
        <el-table-column align="center" label="添加时间" width="230">
          <template slot-scope="scope"> {{ scope.row.min_hour }}<span style="margin: 5px">---</span>{{ scope.row.max_hour }} </template>
        </el-table-column>
        <el-table-column align="center" label="选中员工" prop="user_str" width="300px">
          <template slot-scope="scope">
            <div class="column-content">
              <div v-for="(data, ind) of JSON.parse(JSON.stringify(scope.row.user_str))" :key="ind" class="name">
                {{ data.name }}
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" style="margin-bottom: 10px" @click="editConfig(scope)">编辑</el-button>
            <el-button type="danger" size="mini" style="margin-bottom: 10px" @click="deleteConfig(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination-right
        :current-page="query.page"
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      /> -->
    </div>
    <el-dialog :title="{ add: '添加', edit: '编辑' }[mode]" :visible.sync="configshow" :append-to-body="true" :destroy-on-close="true" :close-on-click-modal="false" width="50%" @close="refresh"
      ><Bandstaff ref="bandstaffview" :mode="mode" :classify="classify" :id-row="idRow" :all-data="classify === 1 ? allData : null" @bandarr="bandarr" />
    </el-dialog>
  </div>
</template>

<script>
import Bandstaff from '../../enterprise/components/friendsBandstaff.vue'
// import PaginationRight from '@/components/PaginationRight/index.vue'
import { friendsList, friendConfigDel } from '@/api/friendsConfig'
export default {
  // components: { Bandstaff, PaginationRight },
  components: { Bandstaff },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        corp_id: '',
        corp_userid: []
      },
      query: {
        page: 1,
        pageSize: 10,
        keywords: null
      },
      total: 0,
      chatid: this.$route.query.corp_id || '',
      FriendsList: [],
      showload: true,
      mode: '',
      configshow: false,
      classify: 0,
      idRow: 0,
      allData: []
    }
  },
  created() {
    this.getFriendsList()
  },
  activated() {
    this.getFriendsList()
  },
  mounted() {},
  methods: {
    getShow() {
      false
    },
    // 请求useropton数据---页面数据
    async getFriendsList(userid, type) {
      // const data = {
      //   corp_primary_id: this.$route.query.corp_id
      // }
      // const res = await friendsList(data)
      // this.FriendsList = res.data.list
    },
    // 删除
    deleteConfig(scope) {
      this.$confirm('您确定删除吗')
        .then(async () => {
          const idRow = scope.row.id.toString()
          await friendConfigDel({ id: idRow })
          this.getFriendsList()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        })
        .catch(() => {})
    },

    bandarr(arr) {
      console.log('arr:父亲中的arr', arr)
      this.dialogVisible = false
      this.configshow = false
      // this.form.corp_userid = arr
      this.getFriendsList()
    },
    // chorwe() {
    //   this.dialogVisibler = true
    //   this.$nextTick(() => {
    //     this.$refs.bandstaffview.sendr(this.form.corp_id, this.form.corp_userid)
    //   })
    // },
    // 添加
    addConfig() {
      this.classify = 0
      this.dialogVisible = true
      this.mode = 'add'
      this.configshow = true
      this.getFriendsList()
      // this.getFriendsList()
      // this.$refs.bandstaffview.list()
    },
    // 编辑
    editConfig(obj) {
      console.log('obj:', obj)
      // this.getFriendsList()
      // console.log('getFriendsList----', this.FriendsList)
      this.classify = 1
      const row = obj.row
      this.allData = row
      this.idRow = row.id
      // console.log('rowallData', this.allData)
      this.mode = 'edit'
      this.showload = false
      this.configshow = true
      // console.log('row====', row)
      this.$refs.bandstaffview.list()
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      // this.getFriendsList()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      // this.getFriendsList()
    },
    refresh() {
      this.getFriendsList()
      this.$refs.bandstaffview.closedata()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.box {
  margin-top: 30px;
}
.namebox {
}
.name {
  margin-right: 15px;
}
.column-content {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 20px;
  max-height: 200px; /* 设置容器最大高度 */
  overflow-y: auto; /* 启用垂直滚动条 */
}
</style>
